import { useEffect } from 'react';
import { useRootNavigation } from '../utils/appNavigationNames';
import { useIsUserLoggedIn } from './useIsUserLoggedIn';

export type UseEnforceLoginStatusArgs = {
    shouldBeLoggedIn: boolean;
};

export type UseEnforceLoginStatusReturnValue = {
    /**
     * If login status is not expected, this will be true and the component should not render children
     */
    shouldBlockRender: boolean;
};

export function useEnforceLoginStatus({
    shouldBeLoggedIn,
}: UseEnforceLoginStatusArgs): UseEnforceLoginStatusReturnValue {
    const rootNavigation = useRootNavigation();
    const { isUserLoggedIn } = useIsUserLoggedIn();
    const shouldBlockRender = isUserLoggedIn !== shouldBeLoggedIn;

    useEffect(() => {
        // this is an invalid state, but makes ts happy.  This case is handled below
        if (isUserLoggedIn === 'loading') return;

        if (shouldBeLoggedIn && !isUserLoggedIn) {
            rootNavigation.navigate('welcome');
        } else if (!shouldBeLoggedIn && isUserLoggedIn) {
            // @ts-expect-error TS2345
            rootNavigation.navigate('app');
        }
    }, [shouldBeLoggedIn, isUserLoggedIn, rootNavigation]);

    if (isUserLoggedIn === 'loading') {
        /**
         * Although the parent should not render children, if the user logs out and back in
         * react navigation may still have some screens mounted.  Just prevent further rendering
         */
        return { shouldBlockRender: true };
    }

    return {
        shouldBlockRender: shouldBlockRender,
    };
}
